(function ($)
{
    $.widget("ui.UpcomingCalendar",
    {
        options:
        {
            SubscribeUrl: null,
            BindSubscribeButton: true
        },

        _destroy: function ()
        {
        },

        _init: function ()
        {
        },

        _create: function ()
        {
            var self = this;
            var jElement = $(self.element);

            if (self.options.BindSubscribeButton == true)
            {
                jElement.on("click", ".subscribe_button", function (e)
                {
                    e.preventDefault();
                    subscribeToCalendars( self.options.SubscribeUrl );
                });
            }

            if (self.options.UseEventPopups == true)
            {
                jElement.find( '.fbcms_upcoming_event .event_title' )
                            .vptooltip({
                                fetchContentElementCallback: function (clickedObj)
                                {
                                    return $( clickedObj ).closest( '.fbcms_upcoming_event' ).find( '.event_details' ).get(0);
                                }
                            });
            }
        }
    });
})(jQuery);